export default {
  List: "/tcs/master-data",
};
